module.exports = __webpack_public_path__ + "media/assets/info-e6782b4fa302c9f2da76fa61ade79d05.svg";